// eslint-disable-next-line import/prefer-default-export
export const SERVICE_TYPES = {
  UPCOMING_SERVICE: {
    type: 'upcoming_services',
    label: 'upcomingService', // will be translated
  },
  PREVIOUS_SERVICE: {
    type: 'previous_services',
    label: 'previousService', // will be translated
  },
};
